import React from "react";
import styled from "styled-components";

const PageContainer = styled.div`
  max-width: 900px;
  margin: 4rem auto;
  padding: 0 1.5rem;
  font-family: 'Inter', sans-serif;
  color: #333;
  line-height: 1.6;

  h1 {
    font-size: 2.2rem;
    margin-bottom: 0.5rem;
    color: #111;
  }

  p.intro {
    font-size: 1.05rem;
    color: #666;
    margin-bottom: 3rem;
  }
`;

const SectionTitle = styled.h2`
  font-size: 1.4rem;
  color: #111;
  margin-top: 2.5rem;
  margin-bottom: 1.2rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #eee;
`;

const FAQGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

const FAQCard = styled.div`
  background: #fdfdfd;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 1.5rem;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  }

  h3 {
    font-size: 1.1rem;
    color: #000;
    margin-bottom: 0.6rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  p {
    color: #4a5568;
    font-size: 0.95rem;
    margin: 0;
  }

  ul {
    margin: 0.5rem 0 0 1.2rem;
    color: #4a5568;
    font-size: 0.95rem;
  }
`;

const FAQ = () => {
  return (
    <PageContainer>
      <h1>Preguntas Frecuentes</h1>
      <p className="intro">
        Encontrá respuestas rápidas a las dudas más habituales sobre nuestro proceso de diseño, desarrollo, costos y mantenimiento web.
      </p>

      {/* 1. Proceso de Trabajo & Tiempos */}
      <SectionTitle>🚀 Proceso de Trabajo y Tiempos</SectionTitle>
      <FAQGroup>
        <FAQCard>
          <h3>¿Cuánto tiempo tarda en estar lista mi página web?</h3>
          <p>
            Los plazos varían según la complejidad del proyecto:
          </p>
          <ul>
                        <li><strong>Web Inicial informativa:</strong>  3 a 5 dias.</li>

            <li><strong>Landing Page / Web Institucional:</strong> 1 a 2 semanas.</li>
            <li><strong>Web Autoadministrable:</strong> 1 a 3 semanas.</li>
            <li><strong>Sitio Corporativo Multipágina:</strong> 2 a 4 semanas.</li>
            <li><strong>Tienda Online (E-commerce) o Plataforma a medida:</strong> 3 a 6 semanas.</li>
          </ul>
        </FAQCard>

        <FAQCard>
          <h3>¿Qué necesito entregar para comenzar el proyecto?</h3>
          <p>
            Para dar inicio requerimos el logo de tu marca, el contenido en texto que desees incluir, imágenes o material gráfico disponible, y completar un breve cuestionario inicial (briefing) para entender tus objetivos e identidad de marca.
          </p>
        </FAQCard>

        <FAQCard>
          <h3>¿Qué pasa si no tengo redactados los textos o no tengo fotos profesionales?</h3>
          <p>
            ¡No te preocupes! Podemos asistirte con la estructuración de contenidos o utilizar bancos de imágenes de alta resolución sin costo adicional para que tu sitio luzca profesional.
          </p>
        </FAQCard>
      </FAQGroup>

      {/* 2. Aspectos Técnicos */}
      <SectionTitle>💻 Aspectos Técnicos y Diseño</SectionTitle>
      <FAQGroup>
        <FAQCard>
          <h3>¿El sitio web se adaptará a celulares y tablets?</h3>
          <p>
            Sí, 100%. Todos los desarrollos de Danyweb son totalmente <em>responsive</em>, diseñados bajo el concepto "Mobile First" para garantizar una navegación rápida y fluida en cualquier dispositivo.
          </p>
        </FAQCard>

        <FAQCard>
          <h3>¿Mi sitio web aparecerá en Google?</h3>
          <p>
            Sí. Todos nuestros desarrollos incluyen optimización SEO técnica básica: indexación en Google Search Console, estructura clara de encabezados, optimización de velocidad de carga y etiquetas meta para buscadores y redes sociales.
          </p>
        </FAQCard>

        <FAQCard>
          <h3>¿Puedo administrar y actualizar el sitio yo mismo?</h3>
          <p>
            Sí.A partir de paginas  web Autoadministrables. Te entregaremos un panel autogestionable intuitivo o un gestor de contenidos personalizado junto con un tutorial paso a paso para que puedas editar textos, cambiar imágenes o agregar productos sin depender de un programador.
          </p>
        </FAQCard>
      </FAQGroup>

      {/* 3. Dominio, Hosting & Mantenimiento */}
      <SectionTitle>🌐 Dominio, Hosting y Mantenimiento</SectionTitle>
      <FAQGroup>
        <FAQCard>
          <h3>¿Tengo que contratar Dominio y Hosting por mi cuenta?</h3>
          <p>Contamos con hosting y dominio incluidos en nuestros paquetes por un año.</p>
          <p>
            Si ya tiene un dominio o quiere uno especifico o prefiere otro servicios de alojamiento , podemos guiarle paso a paso para que compres el dominio (.com, .com.ar, etc.) y el hosting (servidor) en proveedores se su eleccion, y luego configuraremos todo para que tu sitio funcione correctamente.
          </p>
        </FAQCard>

        <FAQCard>
          <h3>¿Qué sucede si algo falla después de la entrega?</h3>
          <p>
            Todos nuestros proyectos cuentan con **30 días de garantía post-lanzamiento** para corregir cualquier fallo técnico o desajuste sin costo adicional.
          </p>
        </FAQCard>

        <FAQCard>
          <h3>¿Ofrecen servicio de mantenimiento mensual?</h3>
          <p>
            Sí, contamos con planes opcionales de mantenimiento que incluyen copias de seguridad continuas, actualizaciones de seguridad, monitoreo de servidor y horas mensuales para pequeños cambios o mejoras.
          </p>
        </FAQCard>
      </FAQGroup>

      {/* 4. Pagos y Cotización */}
      <SectionTitle>💳 Formas de Pago y Contratación</SectionTitle>
      <FAQGroup>
        <FAQCard>
          <h3>¿Cómo se abona el servicio?</h3>
          <p>
            Generalmente trabajamos con un **50% de anticipo** para congelar el presupuesto e iniciar el proyecto, y el **50% restante a la entrega** previa aprobación final antes del lanzamiento público.
          </p>
        </FAQCard>

        <FAQCard>
          <h3>¿Qué medios de pago aceptan?</h3>
          <p>
            Aceptamos transferencias bancarias, Mercado Pago, tarjetas de crédito/débito y pagos internacionales vía PayPal o USDT/Crypto según la conveniencia del cliente.
          </p>
        </FAQCard>
      </FAQGroup>
    </PageContainer>
  );
};

export default FAQ;